<script setup>
// A small tinted label for a coded value that is NOT part of the timesheet
// lifecycle — an account's status, a person's status, whether a feature is
// granted. Lifecycle status (unconfirmed → approved) must use LStatusChip,
// which is locked to the six states and carries a shape as well as a hue.
//
// The `tone` comes from a display-value map's `Tone` (see
// /helpers/display-values.js), never from a raw colour at the call site.
// The label always renders, so colour is never the sole carrier (D6).
// Like LStatusChip, this is a label and is never clickable.
defineProps({
	label: { type: String, required: true },
	// success | danger | pending | neutral | unconfirmed | interactive
	tone: { type: String, default: 'neutral' },
})
</script>

<template>
	<span class="l-tone-pill" :class="'tone-' + tone">{{ label }}</span>
</template>

<style scoped>
/* cursor:default is deliberate — a pill is a label, not a control. */
.l-tone-pill
{
	display: inline-flex;
	align-items: center;
	font-family: var(--font-ui);
	font-size: var(--text-chip);
	font-weight: 600;
	padding: 3px 11px;
	border-radius: var(--r-pill);
	white-space: nowrap;
	cursor: default;
}

.tone-success { color: var(--status-approved-text); background: var(--status-approved-fill); }
.tone-danger { color: var(--status-rejected-text); background: var(--status-rejected-fill); }
.tone-pending { color: var(--status-pending-text); background: var(--status-pending-fill); }
.tone-unconfirmed { color: var(--status-unconfirmed-text); background: var(--status-unconfirmed-fill); }
.tone-interactive { color: var(--interactive-text); background: var(--interactive-tint); }
.tone-neutral { color: var(--text-2); background: var(--surface-sunken); }
</style>
